import { render, staticRenderFns } from "./CloseDialogButton.vue?vue&type=template&id=6db2f7f6&"
import script from "./CloseDialogButton.vue?vue&type=script&lang=js&"
export * from "./CloseDialogButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports